export const secondsToTime = (timestamp: number) => {
    let hours = Math.floor(timestamp / (60 * 60));

    let divisor_for_minutes = timestamp % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let timeObj = {
        h: hours < 10 ? `0${hours}` : hours,
        m: minutes < 10 ? `0${minutes}` : minutes,
        s: seconds < 10 ? `0${seconds}` : seconds
    };
    return timeObj;
}
